<template>
  <BOverlay
    :show="isLoading"
    spinner-variant="primary"
    blur="0"
    opacity=".5"
    rounded="sm"
  >
    <BCard v-if="detailData">
      <!-- Header Section -->
      <DetailHeader
        :data="detailData"
        @cancelled="fetchDetail"
      />

      <!-- Main Content Layout -->
      <div class="grid grid-cols-1 lg:grid-cols-12 gap-[1.5rem]">
        <!-- Left Column -->
        <div class="lg:col-span-7 xl:col-span-8 flex flex-col gap-[1.5rem]">
          <RequestInfoCard
            :data="detailData"
            @updated="fetchDetail"
          />
          <InvoiceInfoCard
            :data="detailData"
            @open-invoice="handleOpenInvoice"
            @on-confirm="fetchDetail"
          />
          <InternalNoteCard
            :data="detailData"
            @saved="fetchDetail"
          />
        </div>

        <!-- Right Column -->
        <div class="lg:col-span-5 xl:col-span-4 flex flex-col gap-[1.5rem]">
          <ExecutionFlowCard
            :data="detailData"
            @open-invoice="handleOpenInvoice"
            @open-churn="handleOpenChurn"
            @off-talent="handleOpenOffTalentConfirm"
            @approve="fetchDetail"
          />
          <ActivityLogCard :activities="detailData.activities || []" />
        </div>
      </div>

      <!-- Invoice Drawer -->
      <InvoiceDrawer
        :drawer="invoiceDrawerState"
        @on-close="invoiceDrawerState.visible = false"
        @on-success="fetchDetail"
      />

      <!-- Churn Drawer -->
      <ChurnDrawer
        :drawer="churnDrawerState"
        @on-close="churnDrawerState.visible = false"
        @on-success="fetchDetail"
      />

      <!-- Off Talent Modal -->
      <ModalOffTalent
        id="modal-off-talent"
        @confirm="handleOffTalentConfirm"
      />
    </BCard>
  </BOverlay>
</template>

<script>
import { komtimAxiosIns } from '@/libs/axios'
import { showSuccess, showError } from '../config'
import DetailHeader from './components/DetailHeader.vue'
import RequestInfoCard from './components/RequestInfoCard.vue'
import InvoiceInfoCard from './components/InvoiceInfoCard.vue'
import InternalNoteCard from './components/InternalNoteCard.vue'
import ExecutionFlowCard from './components/ExecutionFlowCard.vue'
import ActivityLogCard from './components/ActivityLogCard.vue'
import InvoiceDrawer from './InvoiceDrawer.vue'
import ChurnDrawer from './ChurnDrawer.vue'
import ModalOffTalent from './ModalOffTalent.vue'

export default {
  components: {
    DetailHeader,
    RequestInfoCard,
    InvoiceInfoCard,
    InternalNoteCard,
    ExecutionFlowCard,
    ActivityLogCard,
    InvoiceDrawer,
    ChurnDrawer,
    ModalOffTalent,
  },
  data() {
    return {
      isLoading: false,
      detailData: null,
      invoiceDrawerState: {
        visible: false,
        id: 'invoice-drawer',
        title: '',
        data: {},
      },
      churnDrawerState: {
        visible: false,
        id: 'churn-drawer',
        title: '',
        data: {},
      },
    }
  },
  mounted() {
    this.fetchDetail()
  },
  methods: {
    async fetchDetail() {
      const { id } = this.$route.params
      if (!id) return

      try {
        this.isLoading = true
        const url = `/v1/partner_assignment_requests/${id}/detail`
        const res = await komtimAxiosIns.get(url)
        this.detailData = res.data?.data || {}
      } catch {
        showError({ title: 'Gagal Memuat Detail Request!' })
      } finally {
        this.isLoading = false
      }
    },
    handleOpenInvoice(action) {
      this.invoiceDrawerState.title = action
      this.invoiceDrawerState.data = {
        ...this.detailData,
        partner_name: this.detailData?.partner?.name || '',
        talent_name: this.detailData?.talent?.name || '',
        skill_name: this.detailData?.talent?.skill_name || '',
      }
      this.invoiceDrawerState.visible = true
    },
    handleOpenChurn(action) {
      this.churnDrawerState.title = action
      this.churnDrawerState.data = {
        ...this.detailData,
        partner_name: this.detailData?.partner?.name || '',
        talent_name: this.detailData?.talent?.name || '',
        skill_name: this.detailData?.talent?.skill_name || '',
      }
      this.churnDrawerState.visible = true
    },
    handleOpenOffTalentConfirm() {
      this.$bvModal.show('modal-off-talent')
    },
    async handleOffTalentConfirm() {
      if (!this.detailData || !this.detailData.id) return
      try {
        const url = `/v1/partner_assignments/${this.detailData.sk_partner_assignment_id}/unassign`
        await komtimAxiosIns.put(url, {
          partner_assignment_request_id: this.detailData.id,
          effective_date: new Date().toISOString().split('T')[0],
          reason: '',
        })
        showSuccess({ title: 'Berhasil Meng-offkan Talent!' })
        this.fetchDetail()
      } catch {
        showError({ title: 'Gagal Meng-offkan Talent!' })
      }
    },
  },
}
</script>

<style scoped>
::v-deep .btn-primary,
::v-deep .btn-outline-primary {
  border-radius: 10px !important;
  padding: .75rem !important;
}
</style>
